module.exports = __webpack_public_path__ + "img/chpc_index_honor4.9f245fcb.png";